import moment from "jalali-moment"
moment.locale("fa");
const jalaliToTimestamp = (date: string) => {
  if (!date) return moment().unix();

  return moment.from(date, "fa", "YYYY-MM-DD").unix();
};
export default jalaliToTimestamp;
